export default {
  saveFileError: 'Failed to save bin file or map file',
  replaceResourcesError: 'Failed to replace resource',
  uuid2UrlError: 'uuid2url is empty',
  assetTypeError: 'The currently selected picture type is not ASSET_ATLAS',
}
